<template>
  <div
      class="border-0 px-0 py-0 d-inline-flex w-100"
  >
    <div
        class="px-5 py-2 cursor-pointer w-100 text-center border"
        @click="onTabChange(false)"
        :class="!isCustomerLegal ? 'bg-primary' : 'bg-primary-light'"
    >
      {{ translation(translationList.customer_individual, 'Persoana fizica') }}
    </div>
    <div
        class="px-5 py-2 cursor-pointer w-100 text-center border"
        @click="onTabChange(true)"
        :class="isCustomerLegal ? 'bg-primary' : 'bg-primary-light'"
    >
      {{ translation(translationList.customer_legal, 'Persoana juridica') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: [Boolean, null],
      default: false,
    },
  },
  setup(props, { emit }) {
    const isCustomerLegal = ref(props.modelValue);
    const translationList = ref<TranslationList>({});

    const translationStore = useTranslationStore();

    const onTabChange = (newValue: boolean) => {
      isCustomerLegal.value = newValue;
      emit('update:modelValue', newValue);
    };

    watch(() => props.modelValue, (newValue) => {
      isCustomerLegal.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    return {
      isCustomerLegal,
      onTabChange,
      translationList,
      translation,
    };
  },
});
</script>

<style scoped>

</style>
